import script from "./HrMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HrMenu.vue?vue&type=script&setup=true&lang=js"

import "./HrMenu.vue?vue&type=style&index=0&id=010cae88&lang=scss"

const __exports__ = script;

export default __exports__